import React from "react";
import moment from "moment";
import {amountFormatterWithZero} from "../../utils";

const ReconcileDate = (props) => {
    console.dir("reconciledate was rendered")

    const {
        selectedDate,
        portalTransactions,
        batchedTransactions,
        loading,
        batchedLoading,
        timezone,
        themeColor1,
        onBack
    } = props;

    // Calculate summary statistics
    const calculateSummary = (transactions, amountField = 'total') => {
        const charges = transactions.filter(t => !t.isRefunded && parseFloat(t[amountField]) > 0);
        const refunds = transactions.filter(t => t.isRefunded);
        const chargebacks = [];

        return {
            charges: {
                count: charges.length,
                amount: charges.reduce((sum, t) => sum + (parseFloat(t[amountField]) || 0), 0)
            },
            refunds: {
                count: refunds.length,
                amount: refunds.reduce((sum, t) => sum + (parseFloat(t[amountField]) || 0), 0)
            },
            chargebacks: {
                count: chargebacks.length,
                amount: chargebacks.reduce((sum, t) => sum + (parseFloat(t[amountField]) || 0), 0)
            },
            total: {
                count: transactions.length,
                amount: transactions.reduce((sum, t) => sum + (parseFloat(t[amountField]) || 0), 0)
            }
        };
    };

    const portalSummary = calculateSummary(portalTransactions, 'total');
    const batchedSummary = calculateSummary(batchedTransactions, 'amount');

    return (
        <div>
            <div className="mb-3">
                <button
                    className="sos-custom-btn sos-custom-btn-css"
                    onClick={onBack}
                >
                    &larr; Back to Date List
                </button>
                <h3 className="mt-3">Reconciling: {selectedDate.format('dddd, MMMM D, YYYY')}</h3>
            </div>

            {/* Summary Section */}
            <div className="card mb-4">
                <div className="card-header">
                    <h4>Summary</h4>
                </div>
                <div className="card-body">
                    {loading || batchedLoading ? (
                        <div className="text-center">
                            <div className="spinner-border" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    ) : (
                        <div className="row">
                            <div className="col-md-6">
                                <h5>Portal Transactions</h5>
                                <table className="table table-bordered">
                                    <thead className="table-light">
                                    <tr>
                                        <th colSpan="2">Charges</th>
                                        <th colSpan="2">Refunds</th>
                                        <th colSpan="2">Rtns/Chgbks</th>
                                        <th colSpan="2">Totals</th>
                                    </tr>
                                    <tr>
                                        <th>Count</th>
                                        <th>Amount</th>
                                        <th>Count</th>
                                        <th>Amount</th>
                                        <th>Count</th>
                                        <th>Amount</th>
                                        <th>Count</th>
                                        <th>Amount</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr>
                                        <td>{portalSummary.charges.count}</td>
                                        <td>${amountFormatterWithZero(portalSummary.charges.amount)}</td>
                                        <td>{portalSummary.refunds.count}</td>
                                        <td>${portalSummary.refunds.amount > 0 ? '-' : ''}{amountFormatterWithZero(Math.abs(portalSummary.refunds.amount))}</td>
                                        <td>{portalSummary.chargebacks.count}</td>
                                        <td>${amountFormatterWithZero(portalSummary.chargebacks.amount)}</td>
                                        <td><strong>{portalSummary.total.count}</strong></td>
                                        <td><strong>${amountFormatterWithZero(portalSummary.total.amount)}</strong></td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div className="col-md-6">
                                <h5>Batched Transactions Sent To The Bank</h5>
                                <table className="table table-bordered">
                                    <thead className="table-light">
                                    <tr>
                                        <th colSpan="2">Charges</th>
                                        <th colSpan="2">Refunds</th>
                                        <th colSpan="2">Rtns/Chgbks</th>
                                        <th colSpan="2">Totals</th>
                                    </tr>
                                    <tr>
                                        <th>Count</th>
                                        <th>Amount</th>
                                        <th>Count</th>
                                        <th>Amount</th>
                                        <th>Count</th>
                                        <th>Amount</th>
                                        <th>Count</th>
                                        <th>Amount</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr>
                                        <td>{batchedSummary.charges.count}</td>
                                        <td>${amountFormatterWithZero(batchedSummary.charges.amount)}</td>
                                        <td>{batchedSummary.refunds.count}</td>
                                        <td>${batchedSummary.refunds.amount > 0 ? '-' : ''}{amountFormatterWithZero(Math.abs(batchedSummary.refunds.amount))}</td>
                                        <td>{batchedSummary.chargebacks.count}</td>
                                        <td>${amountFormatterWithZero(batchedSummary.chargebacks.amount)}</td>
                                        <td><strong>{batchedSummary.total.count}</strong></td>
                                        <td><strong>${amountFormatterWithZero(batchedSummary.total.amount)}</strong></td>
                                    </tr>
                                    </tbody>
                                </table>
                                {batchedTransactions.length > 0 && (
                                    <div className="alert alert-info">
                                        <strong>Unique Batch IDs:</strong> {
                                            [...new Set(batchedTransactions.map(t => t.batchId || '0'))].join(', ')
                                        }
                                    </div>
                                )}
                            </div>
                        </div>
                    )}
                </div>
            </div>

            {/* All Transactions Section */}
            <div className="card">
                <div className="card-header">
                    <h4>All Transactions</h4>
                </div>
                <div className="card-body" style={{maxHeight: '600px', overflowY: 'auto', position: 'relative'}}>
                    {loading || batchedLoading ? (
                        <div className="text-center">
                            <div className="spinner-border" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        </div>
                    ) : (
                        <>
                            {!Array.isArray(portalTransactions) || portalTransactions.length === 0 ? (
                                <p>No transactions found for this date.</p>
                            ) : (
                                <div style={{overflowX: 'auto'}}>
                                    <table className="table table-bordered table-sm">
                                        <thead className="table-light" style={{position: 'sticky', top: 0, zIndex: 10}}>
                                        <tr>
                                            <th colSpan="4" className="text-center" style={{backgroundColor: themeColor1, color: '#fff'}}>Portal Transactions</th>
                                            <th colSpan="5" className="text-center" style={{backgroundColor: themeColor1, color: '#fff'}}>Batched Transactions Sent To The Bank</th>
                                        </tr>
                                        <tr>
                                            <th style={{backgroundColor: '#f8f9fa'}}>Transaction ID</th>
                                            <th style={{backgroundColor: '#f8f9fa'}}>Name</th>
                                            <th style={{backgroundColor: '#f8f9fa'}}>
                                                Transaction Date
                                                <div style={{fontSize: '0.85em', fontWeight: 'normal'}}>({timezone})</div>
                                            </th>
                                            <th style={{backgroundColor: '#f8f9fa'}}>Total</th>
                                            <th style={{backgroundColor: '#f8f9fa'}}>Name</th>
                                            <th style={{backgroundColor: '#f8f9fa'}}>
                                                Transaction Date
                                                <div style={{fontSize: '0.85em', fontWeight: 'normal'}}>({timezone})</div>
                                            </th>
                                            <th style={{backgroundColor: '#f8f9fa'}}>
                                                Settlement Date
                                                <div style={{fontSize: '0.85em', fontWeight: 'normal'}}>({timezone})</div>
                                            </th>
                                            <th style={{backgroundColor: '#f8f9fa'}}>Batch ID</th>
                                            <th style={{backgroundColor: '#f8f9fa'}}>Total</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {(() => {
                                            const batchedMap = {};
                                            batchedTransactions.forEach(txn => {
                                                batchedMap[txn.transactionId] = txn;
                                            });

                                            const portalRows = portalTransactions.map((portalTxn, idx) => {
                                                const batchedTxn = batchedMap[portalTxn.transactionId];

                                                if (batchedTxn) {
                                                    batchedMap[portalTxn.transactionId] = { ...batchedTxn, _used: true };
                                                }

                                                return (
                                                    <tr key={`portal-${idx}`}>
                                                        <td>{portalTxn.transactionId}</td>
                                                        <td>{portalTxn.payerFirst} {portalTxn.payerLast}</td>
                                                        <td>
                                                            {portalTxn.createdAt
                                                                ? `${moment(portalTxn.createdAt).format('MM/DD/YY HH:mm:ss')} ${timezone}`
                                                                : '-'}
                                                        </td>
                                                        <td>${amountFormatterWithZero(portalTxn.total)}</td>

                                                        {batchedTxn ? (
                                                            <>
                                                                <td>{batchedTxn.firstName} {batchedTxn.lastName}</td>
                                                                <td>
                                                                    {batchedTxn.saleDate
                                                                        ? moment(batchedTxn.saleDate, 'YYYYMMDDHHmmss').format('MM/DD/YY HH:mm:ss')
                                                                        : '-'}
                                                                </td>
                                                                <td>
                                                                    {batchedTxn.settleDate
                                                                        ? moment(batchedTxn.settleDate, 'YYYYMMDDHHmmss').format('MM/DD/YY HH:mm:ss')
                                                                        : '-'}
                                                                </td>
                                                                <td><strong>{batchedTxn.batchId || '0'}</strong></td>
                                                                <td>${amountFormatterWithZero(batchedTxn.amount)}</td>
                                                            </>
                                                        ) : (
                                                            <td colSpan="5" className="text-center text-muted">
                                                                <em>Not found in batched transactions</em>
                                                            </td>
                                                        )}
                                                    </tr>
                                                );
                                            });

                                            const unmatchedBatchedRows = batchedTransactions
                                                .filter(txn => !batchedMap[txn.transactionId]?._used)
                                                .map((batchedTxn, idx) => (
                                                    <tr key={`batched-${idx}`}>
                                                        <td>{batchedTxn.transactionId}</td>
                                                        <td colSpan="3" className="text-center text-muted">
                                                            <em>Not found in portal transactions</em>
                                                        </td>
                                                        <td>{batchedTxn.firstName} {batchedTxn.lastName}</td>
                                                        <td>
                                                            {batchedTxn.saleDate
                                                                ? moment(batchedTxn.saleDate, 'YYYYMMDDHHmmss').format('MM/DD/YY HH:mm:ss')
                                                                : '-'}
                                                        </td>
                                                        <td>
                                                            {batchedTxn.settleDate
                                                                ? moment(batchedTxn.settleDate, 'YYYYMMDDHHmmss').format('MM/DD/YY HH:mm:ss')
                                                                : '-'}
                                                        </td>
                                                        <td><strong>{batchedTxn.batchId || '0'}</strong></td>
                                                        <td>${amountFormatterWithZero(batchedTxn.amount)}</td>
                                                    </tr>
                                                ));

                                            return [...portalRows, ...unmatchedBatchedRows];
                                        })()}
                                        </tbody>
                                    </table>
                                </div>
                            )}
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ReconcileDate;
